/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundLoanRequestDto } from '../../models/backend-patched-venture-fund-loan-request-dto';
import { BackendVentureFundLoanDto } from '../../models/backend-venture-fund-loan-dto';

export interface VentureFundsVentureFundLoansPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedVentureFundLoanRequestDto;
}

export function ventureFundsVentureFundLoansPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundLoansPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundLoansPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundLoanDto>;
    }),
  );
}

ventureFundsVentureFundLoansPartialUpdate$FormData.PATH = '/api/venture_funds/venture-fund-loans/{id}/';
